import ThemeHelper from '@app/shared/layout/themes/ThemeHelper';
import { AppConsts } from '@shared/AppConsts';
import StyleLoaderService from '@shared/utils/style-loader.service';
import rtlDetect from 'rtl-detect';

import { ThemeAssetContributorFactory } from './ThemeAssetContributorFactory';

class DynamicResourcesHelper {
    static loadResources(callback: () => void): void {
        Promise.all([DynamicResourcesHelper.loadStyles()])
            .then(() => {
                callback();
            });
    }

    static loadStyles(): Promise<any> {
        const theme = ThemeHelper.getTheme();

        const isRtl = rtlDetect.isRtlLang(abp.localization.currentLanguage.name);

        if (isRtl) {
            document.documentElement.setAttribute('dir', 'rtl');
        }

        const skin = ThemeHelper.darkMode()
            ? 'dark'
            : 'light';
        document.documentElement.setAttribute('data-bs-theme', skin);

        const cssPostfix = isRtl
            ? '.rtl'
            : '';
        const styleLoaderService = new StyleLoaderService();

        const styleUrls = [
            AppConsts.appBaseUrl +
            '/assets/prime-ng/primeng.min.css',
            AppConsts.appBaseUrl +
            '/assets/prime-ng/lara-light-blue/theme.css',
            AppConsts.appBaseUrl +
            '/assets/metronic/themes/' +
            theme +
            '/css/style.bundle' +
            cssPostfix.replace('-', '.') +
            '.css',
            AppConsts.appBaseUrl +
            '/assets/metronic/themes/' +
            theme +
            '/plugins/global/plugins.bundle' +
            cssPostfix.replace('-', '.') +
            '.css',
        ].concat(DynamicResourcesHelper.getAdditionalThemeAssets());

        DynamicResourcesHelper.setBodyAttributes();
        styleLoaderService.loadArray(styleUrls);

        if (isRtl) {
            styleLoaderService.load(AppConsts.appBaseUrl + '/assets/common/styles/abp-zero-template-rtl.min.css');
        }

        return Promise.resolve(true);
    }

    static getAdditionalThemeAssets(): string[] {
        const assetContributor = ThemeAssetContributorFactory.getCurrent();
        if (!assetContributor) {
            return [];
        }

        return assetContributor.getAssetUrls();
    }

    static setBodyAttributes(): void {
        const assetContributor = ThemeAssetContributorFactory.getCurrent();
        if (!assetContributor) {
            return;
        }

        const attributes = assetContributor.getBodyAttributes();
        for (let i = 0; i < attributes.length; i++) {
            const attr = attributes[i];
            document.body.setAttribute(attr.name, attr.value);
        }
    }
}

export default DynamicResourcesHelper;
